import BaseService from '@/services/BaseService';

class RoleService extends BaseService {
    viewRole = (id) => this.get(`/view-role/${id}`);

    createRole = (data) => this.post('/create-role', data);

    getRoleList = () => this.get('/get-role-list');

    updateRole = (data, id) => this.post(`/edit-role/${id}`, data);

    deleteRole = (id) => this.delete(`/delete-role/${id}`);

    getPermissionList = () => this.get('/get-permission-list');
}

export default new RoleService();
